export default function ECATCategoryController(
  $timeout,
  $rootScope
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.categoryViewType = 'graphical';
  vm.handleExpandCategory = _handleExpandCategory;

  _activate();

  // //////// METHODS //////////

  function _activate() {
  }

  function _handleExpandCategory() {
    $timeout(() => {
      $rootScope.$broadcast('reRenderCategoryGraph', { categoryId: vm.category.categoryId });
    }, 20);
    vm.isExpanded = !vm.isExpanded;
  }
}

ECATCategoryController.$inject = [
  '$timeout',
  '$rootScope'
];
